import {PRIVACY_POLICY_SLUGS} from "@/lib/const";

/**
 * True for Discovery privacy-policy pages. `usePathname()` omits `basePath`,
 * so these are `/privacy`, `/product-privacy`, and the COPPA slugs.
 */
export function isPrivacyPolicyPath(path: string | null | undefined): boolean {
	const normalized = (path ?? "").replace(/\/+$/, "") || "/";
	return PRIVACY_POLICY_SLUGS.some((slug) => normalized === `/${slug}`);
}
